export default "__VITE_ASSET__DleHJzAm__"